import { useAppSelector } from '../store/hooks';
import { getA11yTokens } from '../theme4d';

/** Color tokens for the active accessibility contrast mode (normal / high contrast). */
export const useA11yTokens = () => {
    const contrast = useAppSelector((state) => state.main.a11yContrast);
    return getA11yTokens(contrast);
};
